import { roleStyle, type ChipRole } from '../../lib/roleStyles';

export default function RoleChip({ role }: { role: ChipRole | string | null | undefined }) {
  const s = roleStyle(role);
  return (
    <span style={{
      fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase',
      padding: '5px 6px', borderRadius: 3,
      color: s.color, background: s.background,
    }}>
      {s.label}
    </span>
  );
}
